import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { SippApi } from '../../../services/SippExpress'
import {
  WaterTestKitRequest,
  WaterTestKitRequestsInitialState,
} from '../waterTestKitRequests.slice'

interface RequestOptions {
  email: string
  options?: AxiosRequestConfig
}
export const fetchUserWaterTestKitRequestsAsync = createAsyncThunk<
  Partial<WaterTestKitRequest>[],
  RequestOptions
>('waterTestKits/fetchByUser', async ({ email, options }, { rejectWithValue }) => {
  try {
    const response = (await SippApi.fetchUserWaterTestKitRequests(email, options)) as AxiosResponse<
      Partial<WaterTestKitRequest>[]
    >

    return response.data
  } catch (err: any) {
    return rejectWithValue(
      err.response?.data || {
        message: 'Unexpected error occurred',
        errors: [],
      },
    )
  }
})

export const fetchUserWaterTestKitRequestsBuilder = (
  builder: ActionReducerMapBuilder<WaterTestKitRequestsInitialState>,
) => {
  builder.addCase(fetchUserWaterTestKitRequestsAsync.pending, (state) => {
    state.loading = true
    state.error = false
  })
  builder.addCase(fetchUserWaterTestKitRequestsAsync.fulfilled, (state, action) => {
    state.loading = false
    state.error = false
    state.data = action.payload
  })
  builder.addCase(fetchUserWaterTestKitRequestsAsync.rejected, (state) => {
    state.loading = false
    state.error = true
  })
}
